import React from "react";
import { Select } from "antd";
import "antd/dist/antd.css";
import { Button } from "react-bootstrap";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
// import { Link } from "react-router-dom";

const SearchBar = () => {
  const { Option } = Select;

  const navigate = useNavigate();

  const [condition, setCondition] = useState();
  const handleConditionChange = (value) => {
    setCondition(value);
  };

  const [category, setCategory] = useState();
  const handleCategoryChange = (value) => {
    setCategory(value);
  };

  const [bedrooms, setBedrooms] = useState();
  const handleBedroomsChange = (value) => {
    setBedrooms(value);
  };

  const [city, setCity] = useState();
  const handleCityChange = (value) => {
    setCity(value);
  };

  const onSubmit = () => {
    let url = `/living-places/?`;
    if(city) {
      url += `&city=${city}`
    }
    if(category) {
      url += `&category=${category}`
    }
    if(condition) {
      url += `&condition=${condition}`
    }
    if(bedrooms) {
      url += `&bedrooms=${bedrooms}`
    }

    navigate(url);
  };
  return (
    <>
      <h2>Find a place to rent anywhere in the world!</h2>
      <p className="mb-4">Give rent your apartment without any hidden cost</p>
      <div className="d-flex align-items-center justify-content-between">
        <div className="me-3 d-flex flex-column w-100">
          <label className="fs-6 fw-bold mb-2">City</label>
          <Select
            style={{ width: "100%" }}
            showSearch
            placeholder="Select a City"
            optionFilterProp="children"
            onChange={handleCityChange}
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
          >
            <Option value="Paris">Paris</Option>
            <Option value="Berlin">Berlin</Option>
            <Option value="Rome">Rome</Option>
            <Option value="New York">New York</Option>
            <Option value="Madrid">Madrid</Option>
            <Option value="Sydney">Sydney</Option>
            <Option value="Barcelona">Barcelona</Option>
            <Option value="Dubai">Dubai</Option>
          </Select>
        </div>

        <div className="me-3 d-flex flex-column w-100">
          <label className="fs-6 fw-bold mb-2">Condition</label>
          <Select style={{ width: "100%" }} onChange={handleConditionChange}>
            <Option value="New">New</Option>
            <Option value="Second hand">Second hand</Option>
          </Select>
        </div>
        <div className="me-3 d-flex flex-column w-100">
          <label className="fs-6 fw-bold mb-2">Category</label>
          <Select style={{ width: "100%" }} onChange={handleCategoryChange}>
            <Option value="flat">Flat</Option>
            <Option value="apartment">Apartment</Option>
            <Option value="penthouse">Penthouse</Option>
            <Option value="duplex">Duplex</Option>
            <Option value="house">House</Option>
          </Select>
        </div>
        <div className="me-3 d-flex flex-column w-100">
          <label className="fs-6 fw-bold mb-2">Bedrooms</label>
          <Select style={{ width: "100%" }} onChange={handleBedroomsChange}>
            <Option value="1">1</Option>
            <Option value="2">2</Option>
            <Option value="3">3</Option>
            <Option value="4">4</Option>
            <Option value="5">5</Option>
          </Select>
        </div>
        <div className="mt-auto ms-1">
          <Button onClick={onSubmit} as="input" type="submit" value="Submit" />
        </div>
      </div>
    </>
  );
};

export default SearchBar;
